import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IGetLikeByEntityIdAndUserId } from '@/Module/Lesson/Model/ApiModel/IGetLikeByEntityIdAndUserId';
import type { ILike } from '@/Module/Lesson/Model/DataModel';
import lessonService from '@/Module/Lesson/Service/LessonService';
import type { IState } from '@/Module/Store/Model';

export const getLikeLessonByIdAction = createAsyncThunk<ILike, IGetLikeByEntityIdAndUserId['entityId']>(
  'like/getLike',
  (entityId, { signal, getState }) => {
    return lessonService
      .getLikeByEntityIdAndUserId(
        {
          entityId,
          userId: (getState() as IState).auth.person?.userId!,
          likeEntityTypeId: 1,
        },
        {
          disabledAutoError: true,
        },
        signal,
      )
      .then(({ data: { data } }) => data);
  },
);
